import React, { useState, useEffect } from 'react';
import { IntlProvider, FormattedMessage } from 'react-intl';
import messagesEn from '../tests/test1-en.json'; // Your English translations
import messagesRu from '../tests/test1-ru.json'; // Your Russian translations

const messages = {
  'en': messagesEn,
  'ru': messagesRu/*,
  'es': messagesEn,
  'fr': messagesEn,
  'ko': messagesEn,
  'ro': messagesEn,
  'uk': messagesEn,
  'zh-TW': messagesEn,
  'zh': messagesEn,
  'base-en': messagesEn
*/
};

// Detect the browser language
//const language = navigator.language.split(/[-_]/)[0]; // Language without region code

/*
const getBrowserLanguage = () => {
  const language = navigator.language.split(/[-_]/)[0]; // Language without region code
  return messages[language] ? language : 'en'; // Фолбэк на английский, если язык не поддерживается
};

const language = getBrowserLanguage();
*/
const questions = [
  {
    id: 'relationship_problem',
    options: ['avoid_conflict', 'express_calmly', 'seek_compromise', 'feel_irritated'],
  },
  {
    id: 'partner_dissatisfaction',
    options: ['ignore_feelings', 'listen_understand', 'get_offended', 'seek_immediate_solution'],
  },
  {
    id: 'partner_disappointment',
    options: ['forget_not_discuss', 'share_when_ready', 'show_partner_wrong', 'understand_motives'],
  },
  {
    id: 'discuss_important_issues',
    options: ['text_email', 'in_person', 'phone_call', 'not_discuss_unless_necessary'],
  },
  {
    id: 'communication_qualities',
    options: ['honesty_even_if_hurts', 'tact_attention', 'humor_ease', 'support_comfort'],
  },
];


const MyFormattedMessage = ({ id, defaultMessage, lang }) => {
    if (!id) {
        console.error('An `id` must be provided to format a message.');
        return null; // или можно вернуть defaultMessage, если он предоставлен
      }

  const localeMessages = messages[lang] || messages['en'];
  const message = localeMessages[id] || defaultMessage;
  return <>{message}</>;
};


const Test = ({ onClose, tinode, isNeedTest, intl, eventToGAnalitycs }) => {
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [answers, setAnswers] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [testOut, setTestOut] = useState(null);
    const [testOutDesc, setTestOutDesc] = useState(null);
    const [resultFromServer, setResultFromServer] = useState("");
    const [isRunningCall, setIsRunningCall] = useState(false);
    const [isFirstShow, setIsFirstShow] = useState(false);
    const [error, setError] = useState(""); // Added state for error handling
    const [language, setLanguage] = useState("");

    const getBrowserLanguage = () => {
      //const language = navigator.language.split(/[-_]/)[0]; // Language without region code
      const language = intl.locale.split(/[-_]/)[0];
      return messages[language] ? language : 'en'; // Фолбэк на английский, если язык не поддерживается
    };
    
    useEffect(() => {
      setLanguage(getBrowserLanguage());
      //console.info("language", language);
    }, []); // Пустой массив зависимостей гарантирует, что эффект выполнится один раз после монтирования компонента



    

    const handleOptionChange = (questionId, option) => {
      setAnswers(prevAnswers => ({ ...prevAnswers, [questionId]: option }));
    };
  
    

    const handleSubmit = (event) => {
      event.preventDefault();
      if (currentQuestionIndex < questions.length - 1) {
        setCurrentQuestionIndex(currentQuestionIndex + 1);
      } else {
        eventToGAnalitycs('show_testview_result');
        setSubmitted(true); 
        setTestOut(null); // intl.formatMessage({ id: "lerror.chat.general" })
        setTestOutDesc(null);
        getResult();
          

      }
    };
  
    const handleReset = () => {
      setAnswers({});
      setSubmitted(false);
      setCurrentQuestionIndex(0);
      setTestOut(null);
      setTestOutDesc(null);
      //onClose();
      setError(""); // Reset error on close
    };

    const handleClose = (newIsNeedTest = isNeedTest) => {

        setSubmitted(false);
        setIsRunningCall(false);
        setResultFromServer("");

        if (newIsNeedTest != isNeedTest) {
            onClose(false);
        } else {
            onClose();
        }
        setError(""); // Reset error on close

    }

    const handleSaveResult = async () => {
        eventToGAnalitycs('show_testview_save');
        const topic = tinode.getMeTopic();  
        const query = topic.startMetaQuery().withDesc().build();


       
        query.desc.inchatgpt = testOut + " #f" + testOutDesc + "#f" ;
        query.desc.inchatgpttype = "savetest";
        //console.info('query:');
        //console.info(query);
        
        
        try {

          const result = await topic.getMeta(query);
          //const text = result && result.desc.outchatgpt !== "" ? result.desc.outchatgpt : "Error from server. Try again";
    
         
          
          //console.log('Success:', result);
          handleClose(false);
        } catch (error) {
          console.error('Error:', error);
          setError(intl.formatMessage({ id: "error.chat.general" }) + " (1003)");
          
        } finally {
          //clearInterval(loadingInterval); // Stop updating loading dots
          //this.setState({ isLoading: false, loadingDots: '' }); // Reset loading state
        }

      };

      
    const showResultToScr = (text) => {
      const parts = text.split("#f");

      
      const filteredParts = parts.filter(Boolean);

      const textM = filteredParts[0];
      const textC = filteredParts.length > 1 ? filteredParts[1] : "";

      setTestOut(textM);
      setTestOutDesc(textC);

    }


    const getResult = async () => {
       
        setIsFirstShow(false);
        setIsRunningCall(true);
        const topic = tinode.getMeTopic();  
        const query = topic.startMetaQuery().withDesc().build();


        const output = questions.map(question => {
            const questionText = messages[language][`test.${question.id}`] || question.id;
            const answerText = messages[language][`test.${answers[question.id]}`] || answers[question.id] || "No answer";
            return `Question: ${questionText}, Answer: ${answerText}`;
        }).join('\n');
  
        query.desc.inchatgpt = output;
        query.desc.inchatgpttype = "test";
        query.desc.inchatgptlang = language; 
        //console.info('language:', language);
        //console.info(query);
        
        
        try {

          const result = await topic.getMeta(query);
          if (!result || result.desc.outchatgpt === "") {
            setError(intl.formatMessage({ id: "error.chat.general" }) + " (1005)");
          } else {
            const text = result.desc.outchatgpt ;
      
            showResultToScr(text);
            setIsRunningCall(false);
            console.log('Success:', result);
          }
        } catch (error) {
          console.error('Error:', error);
          setError(intl.formatMessage({ id: "error.chat.general" }) + " (1004)");
          setIsRunningCall(false);
        } finally {
          
          setIsRunningCall(false);
        }
      }

      const showFirstResult = async () => {
       
       // console.info('start showFirstResult');

        const topic = tinode.getMeTopic();  
        const query = topic.startMetaQuery().withDesc().build();
  
        query.desc.inchatgpttype = "gettest";
        //console.info('showFirstResult query:');
        //console.info(query);
        
        
        try {

          const result = await topic.getMeta(query);
          if (!result || result.desc.outchatgpt === "") {
            setError(intl.formatMessage({ id: "error.chat.general" }) + " (1007)");
          } else {
            const text = result.desc.outchatgpt ;
      
            setResultFromServer(text)
            showResultToScr(text);

            console.log('Success:', result);
            setIsRunningCall(false);
            setIsFirstShow(true);
          }
        } catch (error) {
          console.error('Error:', error);
          setError(intl.formatMessage({ id: "error.chat.general" }) + " (1008)");
          setIsRunningCall(false);
        } finally {
            setIsRunningCall(false);
          
        }
      }
    
    let showResult = false;

    if ( !(isNeedTest || resultFromServer != "" || isRunningCall)) {
       
        setIsRunningCall(true);
        setSubmitted(true);
        //testOut = "Load results...";
        setTestOut(null);
        setTestOutDesc(null);
        showResult = true;
        showFirstResult();
    }

    const isCurrentQuestionAnswered = answers[questions[currentQuestionIndex].id] !== undefined;

    return (
        <div>
        {submitted  ? (
                <div>
                  <h3><FormattedMessage id="test_your_result" defaultMessage="Your Test Results" description="Your Test Results" /></h3>
                  <div className="card">
                    {isRunningCall || testOut === null  ? <div>  <FormattedMessage id="loading" defaultMessage="Loading..." description="Loading..." /> </div> :
                    <div  dangerouslySetInnerHTML={{ __html: testOut.replace(/\n/g, '<br />') }} />
                    }

                    {isRunningCall || testOutDesc === null  ? <div>  </div> :
                    <div>
                      <div className="divider"/>
                      <div dangerouslySetInnerHTML={{ __html: testOutDesc.replace(/\n/g, '<br />') }} />
                    </div>  
                    }
                  </div>
                    <div className="dialog-buttons"  > {/*className="dialog-buttons"  style="align-items: center;"*/}
                    <button className="outline" type="button" onClick={handleReset}>
                        <FormattedMessage id="test_restart" defaultMessage="Restart" description="Restart" />
                    </button>
                    {!isFirstShow &&
                    <button className="primary" type="button" onClick={handleSaveResult} disabled={isRunningCall || error || testOut === null  } >
                            <FormattedMessage id="test_save" defaultMessage="Save result" description="Save result" />
                    </button>}

                    <button className="secondary" type="button" onClick={() => handleClose()}>
                            <FormattedMessage id="test_cancel" defaultMessage="Cancel" description="Cancel" />
                    </button>
                  </div>

            </div>
          ) : 

            <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                currentQuestionIndex === index && (
                    <div key={index}>
                    <div className="test-question">
                        <MyFormattedMessage id={`test.${question.id}`} defaultMessage="Question" lang = {language} />
                        <span> {`(${currentQuestionIndex + 1}/${questions.length})`}</span>
                    </div>
                    <div onChange={(e) => handleOptionChange(question.id, e.target.value)}>
                        {question.options.map((option) => (
                            <div>
                                <label key={option} className="test-option">
                                    <input
                                    type="radio"
                                    value={option}
                                    name={question.id}
                                    checked={answers[question.id] === option}
                                    onChange={() => {}}
                                    />
                                    <MyFormattedMessage id={`test.${option}`} defaultMessage="Option" lang = {language} />
                                </label>
                        </div>
                        ))}
                    </div>
                    </div>
                )
                ))}
                <div className="dialog-buttons"  >
                    {currentQuestionIndex > 0 && (
                    <button className="outline" type="button" onClick={() => setCurrentQuestionIndex(currentQuestionIndex - 1)}>
                        <FormattedMessage id="test_previous" defaultMessage="Previous" description="Previous" />
                    </button>
                    )}

                    {currentQuestionIndex < questions.length - 1 && (
                    <button className="primary" type="submit" disabled={!isCurrentQuestionAnswered}>
                        <FormattedMessage id="test_next" defaultMessage="Next" description="Next" />
                    </button>
                    )}
                    {currentQuestionIndex === questions.length - 1 && (
                    <button className="primary" type="submit" disabled={!isCurrentQuestionAnswered}>
                        <FormattedMessage id="test_submit" defaultMessage="Submit" description="Submit" />
                    </button>
                    )}

                    <button className="secondary" type="button" onClick={() => handleClose()}>
                        <FormattedMessage id="test_cancel" defaultMessage="Cancel" description="Cancel" />
                    </button>

                    
                </div>
            </form>
            
        }
        {error && <div className="error-message">{error}</div>} {/* Display error messages here */}
        </div>
    )
  };
  
const TestComponentWrapper = ({ onClose, tinode, isNeedTest, intl, eventToGAnalitycs }) => (
  <Test 
    onClose={onClose} 
    tinode={tinode} 
    isNeedTest={isNeedTest}
    
    intl = {intl}
    eventToGAnalitycs = {eventToGAnalitycs}
  />
);
  
  export default TestComponentWrapper;